var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden-xs",attrs:{"id":"GoTop"},on:{"click":function($event){return _vm.GoTop()}}},[_c('img',{staticClass:"top-icon",attrs:{"src":"https://grow-website-ol.oss-accelerate.aliyuncs.com/cn-assets/new-images/back-top.png"}}),_vm._v("\n  Top\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6157a147","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoTop.vue
// module id = null
// module chunks = 